//
//
//
//
//
//
//
//
//
//
//
//
//

import { faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'TaskEscrow',
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    /**
     * Money icon
     * @returns {IconDefinition}
     */
    moneyIcon () {
      return faHandHoldingUsd
    },

    /**
     * Get balance without fee, only 5 decimal places
     * @returns {string}
     */
    balance () {
      return this.task?.escrowBalanceFormatted
    }
  }
}
